module.exports = __webpack_public_path__ + "static/media/ring_size_guide.a42d5ff0.pdf";